import {
  BookOutlined,
  DollarCircleOutlined,
  FileOutlined,
  HomeOutlined,
  LogoutOutlined,
  MenuOutlined,
  NotificationOutlined,
  SettingOutlined,
} from "@ant-design/icons";
import { Button, Dropdown } from "antd";
import { useNavigate } from "react-router-dom";
import { useChat } from "src/contexts/chat.context";
import { useStores } from "src/hooks";
import { ChatOption } from "src/modules/ai-agent/enums";
import { Routes } from "src/routes";
import { dictionary, i18n } from "src/utils";

export default function MobileMenu() {
  const { setOption } = useChat();
  const navigate = useNavigate();

  const { auth } = useStores();

  function onClick({ key }: { key: string }) {
    navigate(key);
  }

  const onSignOut = async (): Promise<void> => {
    await auth.logout();
    setOption(ChatOption.NONE);
    navigate(Routes.LOGIN);
  };

  return (
    <Dropdown
      className="mobile-menu"
      placement="bottomRight"
      menu={{
        items: [
          { key: Routes.HOME, label: i18n(dictionary.menu.home), icon: <HomeOutlined />, onClick },
          {
            key: Routes.REGISTRATION,
            label: i18n(dictionary.menu.registration),
            icon: <BookOutlined />,
            children: [
              { key: Routes.EMPLOYER, label: i18n(dictionary.menu.employer), onClick },
              { key: Routes.EMPLOYEE, label: i18n(dictionary.menu.employee), onClick },
              { key: Routes.DOCUMENT, label: i18n(dictionary.label.document, { count: 2 }), onClick },
              { key: Routes.ADMISSION_FLOW, label: i18n(dictionary.menu.admissionFlow), onClick },
              { key: Routes.DOCUMENTATION, label: i18n(dictionary.menu.employmentRelationship), onClick },
            ],
          },
          {
            key: Routes.REPORT,
            label: i18n(dictionary.menu.report),
            icon: <FileOutlined />,
            children: [
              { key: Routes.REPORT_REGISTRATION_FORM, label: i18n(dictionary.menu.registrationForm), onClick },
            ],
          },
          {
            key: Routes.FINANCE,
            label: i18n(dictionary.menu.finance),
            icon: <DollarCircleOutlined />,
            onClick,
          },
          {
            key: Routes.SETTINGS,
            label: i18n(dictionary.menu.setting),
            icon: <SettingOutlined />,
            onClick,
          },
          {
            key: Routes.NEWS,
            label: i18n(dictionary.menu.new),
            icon: <NotificationOutlined />,
            onClick,
          },
          {
            key: "quit",
            label: i18n(dictionary.menu.exit),
            icon: <LogoutOutlined />,
            style: { color: "#ff4d4f" },
            onClick: onSignOut,
          },
        ],
      }}
    >
      <Button
        shape="circle"
        icon={<MenuOutlined />}
      />
    </Dropdown>
  );
}
